// LEGACY: Uses @ion/components. New code should use @metarouter-private/mr-mui components instead.
import { useState } from 'react';
import { useOpen } from '@ion/components';

export default function useDrawerContextValue() {
  const [drawerData, setDrawerData] = useState(null);
  const [isOpen, onOpen, onClose] = useOpen();

  const launchDrawer = data => {
    setDrawerData(data);
    onOpen();
  };

  const onCloseWrapper = () => {
    onClose();
  };

  return {
    launchDrawer,
    drawer: {
      data: drawerData,
      isOpen,
      onClose: onCloseWrapper,
    },
  };
}
